import { useMemo } from "react";
import { Route, BrowserRouter, Routes, HashRouter } from "react-router-dom";
import "./css/App.scss";
import Home from "./page/Home.tsx";
import Introduction from "./page/Introduction.tsx";
import Business from "./page/Business.tsx";
import History from "./page/History.tsx";
import Location from "./page/Location.tsx";
import Product1 from "./page/Product1.tsx";
import Product2 from "./page/Product2.tsx";
import Manufacture from "./page/Manufacture.tsx";
import Header from "./component/Header.tsx";
import Footer from "./component/Footer.tsx";
import FloatingTopButton from "./component/FloatingTopButton.tsx";
import MobileHeader from "./component/MobileHeader.tsx";
import WrapperContext from "./component/WrapperContext.tsx";
import MenuList from "./setting/menu.json";

const App = () => {
  const headerData = useMemo(() => MenuList, []);

  return (
    <BrowserRouter basename="/">
      <Header data={headerData} />
      <MobileHeader data={headerData} />
      <WrapperContext headerData={headerData}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="introduction">
            <Route path="company" element={<Introduction />} />
            <Route path="business" element={<Business />} />
            <Route path="history" element={<History />} />
            <Route path="location" element={<Location />} />
          </Route>
          <Route path="production1" element={<Manufacture />} />
          <Route path="production2">
            <Route path="product1" element={<Product1 />} />
            <Route path="product2" element={<Product2 />} />
          </Route>

          <Route path="*" element={<Home />} />
        </Routes>
      </WrapperContext>
      <Footer />
      <FloatingTopButton />
    </BrowserRouter>
  );
};

export default App;
